import { createAsyncThunk } from '@reduxjs/toolkit'
import { handleError, hasError } from '@repo/shared/api/helpers'
import { BeneficiaryFilters } from '@repo/shared/dtos/beneficiary'
import { SuccessResponseDTO } from '@repo/shared/dtos/generic'
import { DataStatus } from '@repo/ui/utils'

import { Task } from '@/store/task'

import { AsyncThunkConfig, RejectValue } from '../actions'

export const createTasksForBeneficiariesMatchingFilters = createAsyncThunk<
  SuccessResponseDTO,
  {
    filters: BeneficiaryFilters
    fields: Pick<Task, 'title' | 'content'> &
      Partial<Pick<Task, 'categories' | 'cta' | 'dueDate' | 'durationInHours'>>
  },
  AsyncThunkConfig
>(
  'CREATE_TASKS_FOR_BENEFICIARIES_MATCHING_FILTERS',
  async ({ filters, fields }, { getState, extra, rejectWithValue, fulfillWithValue }) => {
    const state = getState()
    const organizationId = state.user.currentOrganizationId
    if (!organizationId) return rejectWithValue(RejectValue.NoOrganization)
    const caseWorker = getState().user.caseWorker
    if (!DataStatus.isFulfilled(caseWorker)) return rejectWithValue(RejectValue.NoCaseWorker)

    const scope = state.beneficiaryList.scope === 'admin' ? 'all' : 'own'
    const res = await extra.altApi.tasks.createMany({
      fields,
      filters,
      organizationId,
      scope,
    })
    if (hasError(res)) return rejectWithValue(handleError(res))
    return fulfillWithValue(res)
  },
)
